<mat-toolbar color="accent" class="flex items-center justify-between gap-4">
  <span>{{ data.row.template.name }}</span>
</mat-toolbar>

<mat-dialog-content>
  <form class="flex flex-col gap-4" [formGroup]="form">
    <mat-slide-toggle
      color="primary"
      class="mb-2"
      formControlName="depositRequired"
      [attr.aria-label]="data.row.template.name + ' deposit required'"
    >
      Deposit required
    </mat-slide-toggle>

    @if (form.controls.depositRequired.value) {
      <pr-deposit-configuration-form
        [form]="form"
        [ariaLabelPrefix]="data.row.template.name"
      />
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      [disabled]="form.controls.depositRequired.value && form.invalid"
      (click)="apply()"
    >
      Apply
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
